module.exports = __webpack_public_path__ + "static/media/skila-bg_img-02-2-pod_600px_width-0_1-@3x.a4ef2c46.png";